import { Guid } from '../../../../../store/model/guid';
import { GetItemByIdTyped } from '../../../../../store/reducers/items/itemsSelectors';
import { Hotspot, isHotspot, NonSequencedFlowItem, PolygonalArrow, SimpleArrow } from '@ael/core-api';
import { FriendlyNameService, IPanorama, KrpanoHotspot, RenderOptions } from '@ael/core-api';

export const hideHandCursor = (hotspotIcon: KrpanoHotspot) => {
  hotspotIcon.handcursor = false;
};

export const disableHotspot = (hotspotIcon: KrpanoHotspot) => {
  hotspotIcon.enabled = false;
};

export const blinkHiddenArea = (panorama: IPanorama, hotspotIcon: KrpanoHotspot, onBlinkFinish?: () => void) => {
  const totalDelayTimeMS = 2500;
  panorama._pano.call(`stoptween(hotspot[${hotspotIcon.name}].alpha)`);
  panorama._pano.call(`stopdelayedcall(delayHotspotAlphaTween)`);
  panorama._pano.call(`tween(hotspot[${hotspotIcon.name}].alpha,1.0,1,default)`);
  panorama._pano.call(
    `delayedcall(delayHotspotAlphaTween,1.5,tween(hotspot[${hotspotIcon.name}].alpha,0.0,1,default))`
  );
  if (onBlinkFinish) {
    setTimeout(() => {
      onBlinkFinish();
    }, totalDelayTimeMS);
  }
};

export const renderNonSequencedFlowHotspots = (
  panorama: IPanorama,
  item: NonSequencedFlowItem,
  getItemById: GetItemByIdTyped,
  createRenderOptions: (hotspot: Hotspot) => RenderOptions,
  exceptFor?: (hotspot: Hotspot) => boolean
) => {
  item.hotspots.forEach((hotspotId: Guid) => {
    const hotspot = getItemById(hotspotId, isHotspot);
    if (exceptFor && exceptFor(hotspot)) {
      return;
    }

    addHotspotToPanorama(panorama, hotspotId, hotspot.position, createRenderOptions(hotspot));
  });
};

export const removeNonSequencedFlowHotspots = (
  panorama: IPanorama,
  item: NonSequencedFlowItem,
  getItemById: GetItemByIdTyped,
  exceptFor?: (hotspot: Hotspot) => boolean
) => {
  item.hotspots.forEach((hotspotId: Guid) => {
    const hotspot = getItemById(hotspotId, isHotspot);
    if (exceptFor && exceptFor(hotspot)) {
      return;
    }

    removeHotspotFromPanorama(panorama, hotspotId);
  });
};

export const addHotspotToPanorama = (
  panorama: IPanorama,
  id: Guid,
  arrow: SimpleArrow | PolygonalArrow,
  renderOptions?: RenderOptions
) => {
  const arrowId = FriendlyNameService.getFriendlyName(id);
  panorama.renderArrowToPano(arrow, arrowId, renderOptions, Math.random() * 500);
};

export const removeHotspotFromPanorama = (panorama: IPanorama, id: Guid) => {
  const arrowId = FriendlyNameService.getFriendlyName(id);
  panorama.removeArrow(arrowId);
};
